import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DividerComponent } from './components';

@NgModule({
  declarations: [DividerComponent],
  imports: [CommonModule],
  exports: [DividerComponent],
})
export class DividerModule {}
